import React, { useMemo } from 'react';
import { HistogramChart } from "@carbon/charts-react";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { transformToGroupValue, expandHistogramBuckets, resolveGroupLabel, resolveFields, buildChartTitle, buildXAxisTitle, buildYAxisTitle, DEFAULT_COLOR_PALETTE } from "../chartHelpers";
import './_index.scss'

const Index = ({chart}) => {
    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData) => {
                const gv = transformToGroupValue(panelData, chart);
                const { valueField } = resolveFields(chart, panelData[0]);
                const groupLabel = resolveGroupLabel(chart, valueField, 'Observación');
                const data = expandHistogramBuckets(gv, groupLabel);
                const chartOptions = {
                    title: buildChartTitle(chart),
                    resizable: true,
                    height: "400px",
                    axes: {
                        bottom: {
                            title: buildXAxisTitle(chart),
                            mapsTo: "value",
                            bins: 10,
                            limitDomainToBins: true
                        },
                        left: {
                            title: buildYAxisTitle(chart),
                            scaleType: "linear",
                            stacked: true,
                            binned: true
                        }
                    },
                    color: { scale: { [groupLabel]: DEFAULT_COLOR_PALETTE[0] } }
                };
                return <HistogramChart options={chartOptions} data={data} />;
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
